import { RouteConfig } from "vue-router";

export const REmployerCompanySummary: RouteConfig = {
  path: "summary",
  name: "EmployerCompanySummary",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-summary" */
      "./VEmployerCompanySummary.vue"
    ),
  meta: {
    title: "Company",
    label: "summary",
    tabName: "employer_company_info",
    alias: "summary",
  },
};
